import { render, staticRenderFns } from "./ContentFeedLikes.vue?vue&type=template&id=0d37160e&scoped=true&"
import script from "./ContentFeedLikes.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedLikes.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedLikes.vue?vue&type=style&index=0&id=0d37160e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37160e",
  null
  
)

export default component.exports